import React from 'react';

import './Success.css';
import MessagePage from '../Controls/GenericMessagePage/MessagePage';
import { Icons } from '@silverfort/sf-components';

const Success = (props) => {
    return (
        <div className="h-full">
            {props.isSuccess && !props.isLoading && (
                <MessagePage
                    bigMsg="Registration almost completed"
                    smallMsgs={[
                        'Close this tab, and click Save Changes in Silverfort Admin Console',
                        'to complete the registration.'
                    ]}
                    icon={Icons.CircleError}
                />
            )}
            {!props.isSuccess && !props.isLoading && (
                <MessagePage
                    bigMsg="Registration Failed"
                    smallMsgs={['Please try again later.']}
                    icon={Icons.CircleError}
                />
            )}
            {props.isLoading && (
                <div className="silverfort-loader">
                    <div className="logo"></div>
                </div>
            )}
        </div>
    );
};

export default Success;
